var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row pt-3 l-m-b-20" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-3 text-right" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { type: "button" },
              on: { click: _vm.toggleSidebar }
            },
            [_vm._v("\n        ADD TEMPLATE\n      ")]
          )
        ])
      ]),
      _vm._v(" "),
      !_vm.templates
        ? [
            _c(
              "vue-content-loading",
              { attrs: { width: 800, height: 450 } },
              _vm._l(15, function(x) {
                return _c("rect", {
                  key: x,
                  attrs: {
                    x: "10",
                    y: 15 * x * 1.4,
                    rx: "5",
                    ry: "5",
                    width: "720",
                    height: "6"
                  }
                })
              })
            )
          ]
        : [
            _c("table", { staticClass: "table m-table table-hover l-m-t-20" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.templates, function(template) {
                    return _c(
                      "tr",
                      {
                        key: template.id,
                        staticClass: "pointer",
                        on: {
                          click: function($event) {
                            _vm.editTemplate(template.id, template.claim_types)
                          }
                        }
                      },
                      [
                        _c("td", [_vm._v(_vm._s(template.id))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(template.name))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(template.subject))]),
                        _vm._v(" "),
                        _c(
                          "td",
                          _vm._l(template.claim_types, function(type, index) {
                            return _c(
                              "span",
                              { key: type.id },
                              [
                                _vm._v("\n              " + _vm._s(type.name)),
                                index + 1 < template.claim_types.length
                                  ? [_vm._v(", ")]
                                  : _vm._e()
                              ],
                              2
                            )
                          })
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.templates && !_vm.templates.length
                    ? _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "text-center",
                            attrs: { colspan: "4" }
                          },
                          [_vm._v("\n            No results found\n          ")]
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ])
          ],
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showCreateSidebar
          ? _c(
              "div",
              { staticClass: "l-modal-mask" },
              [
                _c("settings-create-email-template", {
                  staticClass: "sidebar-right",
                  attrs: { "email-template": _vm.template },
                  on: {
                    cancel: function($event) {
                      _vm.toggleSidebar()
                    },
                    update: _vm.getAllClaimTypes
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showEditSidebar
          ? _c(
              "div",
              { staticClass: "l-modal-mask" },
              [
                _c("settings-edit-email-template", {
                  staticClass: "sidebar-right",
                  attrs: { "email-template": _vm.template },
                  on: {
                    cancel: function($event) {
                      _vm.toggleEditSidebar()
                    },
                    update: _vm.getAllClaimTypes
                  }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-9" }, [
      _c("h1", [_vm._v("Claim templates")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "m-table__heading" }, [
      _c("tr", [
        _c("th", { staticClass: "m-table__id" }, [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Subject")]),
        _vm._v(" "),
        _c("th", [_vm._v("Claim type")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63b4870e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63b4870e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/Mailing/ClaimEmailTemplates.vue
// module id = null
// module chunks = 